<template>
	<div class="">

		<!--header-->
		<app-header headerTitle="اطلاعات خود را وارد کنید"></app-header>

		<!--loading-->
		<div class="loading text-center px-3" v-if="loading">
			<div class="alert alert-blue d-inline-block py-2 px-3">
				<i class="fa fa-refresh fa-spin ml-1 align-middle"></i> در حال بارگذاری ...
			</div>
		</div>

		<div v-else>
			<!--message-->
			<div class="message px-3 text-center" v-if="message">
				<div class="alert alert-warning p-2">
					{{ message }}
				</div>
				<a class="btn btn-link" @click="$router.go(-1)"><i class="fa fa-long-arrow-right"></i> بازگشت</a>
			</div>

			<div class="checkout mt-4 px-3" v-if="!message">
				<form @submit.prevent @submit="submitCheckout()">
					<div class="checkout-form">
						<div class="form-group">
							<div class="input-group">
								<div class="input-group-prepend">
									<div class="input-group-text">
										<i class="fa fa-user fa-fw"></i>
									</div>
								</div>
								<input type="text" class="form-control" placeholder="نام و نام خانوادگی"
									v-model="name"
									:disabled="progress"
									:class="{'error': $v.name.$error}">
							</div>
							<div class="form-error mt-2 mb-3" v-if="$v.name.$error">لطفا نام و نام خانوادگی را وارد کنید.</div>
						</div>
						<div class="form-group">
							<div class="input-group">
								<div class="input-group-prepend">
									<div class="input-group-text">
										<i class="fa fa-phone fa-fw"></i>
									</div>
								</div>
								<input type="text" class="form-control" placeholder="شماره موبایل"
									v-model="mobile"
									:disabled="progress"
									:class="{'error': $v.mobile.$error}">
							</div>
							<div class="form-error mt-2 mb-3" v-if="$v.mobile.$error">لطفا شماره موبایل خود را وارد کنید.</div>
						</div>
						<template v-if="shipping == 'shipping_required'">
							<div class="form-group d-none">
								<div class="input-group">
									<div class="input-group-prepend">
										<div class="input-group-text">
											<i class="fa fa-globe fa-fw"></i>
										</div>
									</div>
									<select class="form-control" 
										v-model="country"
										:disabled="progress"
										@change="countrySelected()"
										:class="{'error': $v.country.$error}">
										<option value="" v-if="!country">انتخاب کشور ...</option>
										<option :key="country.name" v-for="country in countries" :value="country.id">{{ country.name }}</option>
									</select>
								</div>
								<div class="form-error mt-2 mb-3" v-if="$v.country.$error">لطفا کشور خود را انتخاب کنید.</div>
							</div>
							<div class="form-group">
								<div class="input-group">
									<div class="input-group-prepend">
										<div class="input-group-text">
											<i class="fa fa-map fa-fw"></i>
										</div>
									</div>
									<select class="form-control"
										v-model="state"
										:disabled="progress"
										@change="stateSelected()"
										:class="{'error': $v.state.$error}">
										<option value="" v-if="country && !states.length">درحال بارگذاری ...</option>
										<option value="" v-if="!state">انتخاب استان ...</option>
										<option :key="state.name" v-for="state in states" :value="state.id">{{ state.name }}</option>
									</select>
								</div>
								<div class="form-error mt-2 mb-3" v-if="$v.state.$error">لطفا استان خود را انتخاب کنید.</div>
							</div>
							<div class="form-group">
								<div class="input-group">
									<div class="input-group-prepend">
										<div class="input-group-text">
											<i class="fa fa-map-marker fa-fw"></i>
										</div>
									</div>
									<select class="form-control"
										v-model="city"
										:disabled="progress"
										:class="{'error': $v.city.$error}">
										<option value="" v-if="state &&!cities.length">درحال بارگذاری ...</option>
										<option value="" v-if="!city">انتخاب شهر ...</option>
										<option :key="city.name" v-for="city in cities" :value="city.id">{{ city.name }}</option>
									</select>
								</div>
								<div class="form-error mt-2 mb-3" v-if="$v.city.$error">لطفا شهر خود را انتخاب کنید.</div>
							</div>
							<div class="form-group">
								<div class="input-group">
									<div class="input-group-prepend">
										<div class="input-group-text">
											<i class="fa fa-hashtag fa-fw"></i>
										</div>
									</div>
									<input type="text" class="form-control" placeholder="کد پستی"
										v-model="zipcode"
										:disabled="progress"
										:class="{'error': $v.zipcode.$error}">
								</div>
								<div class="form-error mt-2 mb-3" v-if="$v.zipcode.$error">لطفا کد پستی خود را وارد کنید.</div>
							</div>
							<div class="form-group">
								<div class="input-group">
									<div class="input-group-prepend">
										<div class="input-group-text">
											<i class="fa fa-location-arrow fa-fw"></i>
										</div>
									</div>
									<input type="text" class="form-control" placeholder="آدرس"
										v-model="address"
										:disabled="progress"
										:class="{'error': $v.address.$error}">
								</div>
								<div class="form-error mt-2 mb-3" v-if="$v.address.$error">لطفا آدرس خود را وارد کنید.</div>
							</div>
						</template>
					</div>
					<button type="submit" class="checkout-submit btn btn-green btn-lg btn-block position-fixed py-3"
						:disabled="progress">
						<i class="fa fa-check-square"></i>
						{{ progress ? 'کمی صبر کنید ...': 'ثبت سفارش' }}
					</button>
				</form>

				<!-- coupon -->
				<hr>
				<div class="form-group coupon-form">
					<div class="input-group">
						<input type="text" class="form-control" placeholder="کوپن تخفیف"
							v-model="coupon"
							:disabled="progress"
							:class="{'error': $v.coupon.$error}">
						<div class="input-group-append">
							<button class="btn btn-red" type="button" @click="submitCoupon()">اعمال تخفیف</button>
						</div>
					</div>
					<div class="form-error mt-2 mb-3" v-if="$v.coupon.$error">لطفا کوپن تخفیف خود را وارد کنید.</div>
				</div>
				<!-- coupon items -->
				<div class="coupon-items" v-if="coupons && coupons.length > 0">
					<button class="btn btn-secondary mb-2 ml-2"
						:key="couponItem" v-for="couponItem in coupons"
						@click="removeCoupon(couponItem)">
						<i class="fa fa-times"></i>
						{{ couponItem }}
					</button>
				</div>

				<div class="alert alert-success my-2 p-2" v-if="couponSuccess">
					{{ couponSuccess }}
				</div>
				<div class="alert alert-danger my-2 p-2" v-if="couponFailed">
					{{ couponFailed }}
				</div>

				<div class="bg-white px-3 border rounded my-2">
					<div class="d-flex align-items-center justify-content-between my-3" v-if="(discount && discount != 0) || (tax && tax != 0)">
						<div>مبلغ کل:</div>
						<div>
							<span class="font-weight-bold">{{ subtotal }} <small>تومان</small></span>
						</div>
					</div>
					<div class="d-flex align-items-center justify-content-between my-3" v-if="tax && tax != 0">
						<div>مالیات:</div>
						<div>
							<span class="text-red font-weight-bold">{{ tax }} <small>تومان</small></span>
						</div>
					</div>
					<div class="d-flex align-items-center justify-content-between my-3" v-if="discount && discount != 0">
						<div>تخفیف:</div>
						<div>
							<span class="text-red font-weight-bold">{{ discount }} <small>تومان</small></span>
						</div>
					</div>
					<div class="d-flex align-items-center justify-content-between my-3">
						<div>مبلغ قابل پرداخت:</div>
						<div>
							<span class="text-green font-weight-bold">{{ price }} <small>تومان</small></span>
						</div>
					</div>
				</div>

				<a class="btn btn-link" @click="$router.go(-1)"><i class="fa fa-long-arrow-right"></i> بازگشت</a>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from "../components/Header.vue"
	import axios from 'axios'
	import { required } from 'vuelidate/lib/validators'

	export default {
		components: {
			appHeader: Header
		},
		data() {
			return {
				loading: true,
				progress: null,
				message: null,
				name: "",
				mobile: "",
				country: "",
				state: "",
				city: "",
				zipcode: "",
				address: "",
				formData: {},
				countries: [],
				states: [],
				cities: [],
				coupon: "",
				couponSuccess: "",
				couponFailed: "",
				coupons: [],
				token: null,
				cart: {},
				subtotal: "",
				price: "",
				discount: "",
				tax: "",
				shipping: null,
				apiErrors: [],
				submitStatus: null
			}
		},
		validations() {
			if(this.shipping == 'none') {
				return {
					name: {
						required
					},
					mobile: {
						required
					}
				}
			} else {
				return {
					name: {
						required
					},
					mobile: {
						required
					},
					country: {
						required
					},
					state: {
						required
					},
					city: {
						required
					},
					zipcode: {
						required
					},
					address: {
						required
					},
					coupon: {
						required
					}
				}
			}
		},
		methods: {
			getCart() {
				// check cart items and delete cart items
				axios({
					method: "get",
					url: "/site/api/v1/cart",
				})
				.then(response => {
					this.cart = response.data.cart
					this.coupons = (this.cart.coupons) ? this.cart.coupons : null
					this.subtotal = new Intl.NumberFormat().format(this.cart.subtotal)
					this.price = new Intl.NumberFormat().format(this.cart.price)
					this.discount = new Intl.NumberFormat().format(this.cart.discount)
					this.tax = new Intl.NumberFormat().format(this.cart.tax)
					if(this.cart == null || this.cart.items == null) {
						this.message = "محصول به سبد خرید اضافه نشده است، لطفا دوباره تلاش کنید."
						// loading
						setTimeout(() => { this.loading = false }, 500)
					} else {
						this.shipping = (this.cart.status[0] == 'none') ? null : this.cart.status[0]
						// loading
						setTimeout(() => { this.loading = false }, 500)
					}
				})
				.catch((err) => {
					this.apiErrors.push(err.response)
				});
			},
			countrySelected() {
				this.states = []
				this.state = ""
				if(this.country != null) {
					axios({
						method: "get",
						url: "/site/api/v1/mapping/states?country_id="+this.country
					})
					.then(response => {
						this.states = response.data.states
					})
					.catch((err) => {
						this.apiErrors.push(err.response)
					});
				}
			},
			stateSelected() {
				this.cities = []
				this.city = ""
				if(this.country != null) {
					axios({
						method: "get",
						url: "/site/api/v1/mapping/cities?state_id="+this.state
					})
					.then(response => {
						this.cities = response.data.cities
					})
					.catch((err) => {
						this.apiErrors.push(err.response)
					});
				}
			},
			submitCoupon() {

				this.$v.coupon.$touch()
				if (this.$v.coupon.$invalid) {
					this.submitStatus = 'ERROR'
				} else {
					this.submitStatus = 'OK'
				}

				if(this.submitStatus == 'OK') {
					// progress
					this.progress = true

					axios({
						method: "post",
						url: "/site/api/v1/cart/coupons",
						data: {
							code: this.coupon
						}
					})
					.then(response => {
						this.couponDescription = response.data.description
						this.getCart()
						// progress
						setTimeout(() => { this.progress = false }, 500)
					})
					.catch((err) => {
						this.apiErrors.push(err.response)
						this.couponFailed = err.response.data.context.code
						// progress
						setTimeout(() => { this.progress = false }, 500)
					});
				}
			},
			removeCoupon(couponCode) {
				if(confirm("آیا از حذف کوپن مطمئن هستید؟")){
					// progress
					this.progress = true

					axios({
						method: "delete",
						url: "/site/api/v1/cart/coupons?code="+couponCode,
					})
					.then(response => {
						this.couponDescription = response.data.description
						this.getCart()
						// progress
						setTimeout(() => { this.progress = false }, 500)
					})
					.catch((err) => {
						this.apiErrors.push(err.response)
						this.couponFailed = err.response.data.context.code
						// progress
						setTimeout(() => { this.progress = false }, 500)
					});
				}
			},
			submitCheckout() {

				this.$v.name.$touch()
				this.$v.mobile.$touch()
				this.$v.state.$touch()
				this.$v.city.$touch()
				this.$v.zipcode.$touch()
				this.$v.address.$touch()

				if (this.$v.name.$invalid && this.$v.mobile.$invalid && this.$v.state.$invalid && this.$v.city.$invalid && this.$v.zipcode.$invalid && this.$v.address.$invalid) {
					this.submitStatus = 'ERROR'
				} else {
					this.submitStatus = 'OK'
				}

				this.formData = {
					name: this.name,
					mobile: this.mobile,
					country_id: this.country,
					state_id: this.state,
					city_id: this.city,
					address: this.address
				}

				if(this.submitStatus == 'OK') {
					// progress
					this.progress = true

					axios({
						method: "post",
						url: "/site/api/v1/cart/checkout",
						data: this.formData
					})
					.then(response => {
						this.token = encodeURIComponent(response.data.token);
						if(this.shipping != 'none' || this.shipping != null) {
							this.$router.push({
								name: 'shipping',
								query: {
									token: this.token
								}
							})
						} else {
							this.$router.push({
								name: 'payment',
								query: {
									token: this.token
								}
							})
						}
						// progress
						setTimeout(() => { this.progress = false }, 500)
					})
					.catch((err) => {
						this.apiErrors.push(err.response)
						this.message = err.response.data.description
						// progress
						setTimeout(() => { this.progress = false }, 500)
					});
				}
			}
		},
		created() {
			this.getCart()

			// get countries
			axios({
				method: "get",
				url: "/site/api/v1/mapping/countries"
			})
			.then(response => {
				this.countries = response.data.countries
			})
			.catch((err) => {
				this.apiErrors.push(err.response)
			});
		},
		mounted () {
			this.country = '100000103';
			this.countrySelected()
		},
	}
</script>

<style>
[v-cloak] { display: none; }
.checkout { padding-bottom: 100px; padding-top: 66px; }
.checkout-title { font-size: 1.2rem; }
.checkout-submit { border-radius: 0; bottom: 0; right: 0; left: 0; z-index: 10; }
.checkout-submit[disabled] { cursor: default; opacity: 1; }
</style>
